import React from "react";
import Footer from "../../../components/Landing/Footer/Footer";
import Hero from "../../../components/Landing/HeroForm/Hero";
import UpButton from '../../../components/UpButton';
//------------------------------------------------
import Form from '../../../components/Landing/Form';
import { Helmet } from "react-helmet";
//==
import  { useContext , useEffect } from 'react';
import { LanguageContext } from '../../../context/LanguageContext';
//==
const LandingForm = ({scroll , lang , page}) => {
  //==
    let path;
    if(page === 'landing'){
        path = '/landing/form/thanks'
    }else if(page === 'ar-pacs-ris'){
        path = `/landing-${page}/form/thanks`
    }else if(page === 'ar-polyclinic-erp'){
        path = `/landing-${page}/form/thanks`
    }else{
        path = '';
    }
  //==
    const { language, toggleLanguage } = useContext(LanguageContext);
    useEffect(() => {
        toggleLanguage(lang)
    }, );
    return (
        <div>
        <Helmet>
            <title>Millensys - Landing - Form</title>
            <script type="text/javascript">
            {`            
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "qeh6bpz9s1");
            `}
            </script>
        </Helmet>
        <UpButton scroll={scroll} />
        <div>
            <Hero/>
            <Form lang={language} page={page} path={path}/>     
            <Footer/>
        </div>
        </div>
    );
};

export default LandingForm;
